import React from 'react';
import { Navigate } from 'react-router';

const ProtectedRoute = ({ children, user, requiredRole = null, allowedRoles = [] }) => {
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if specific role is required
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/onboarding" replace />;
  }

  // Check if user role is in allowed roles list
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default ProtectedRoute;